import {allCourseTypes} from 'constants/url';
import axios from 'axios';

async function getCourseTypes(token) {
  try {
    const response = await axios.get(`${allCourseTypes}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default getCourseTypes;
